import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

import themeConfig from '../../../../configs/themeConfig';

// ** Get All Module
export const getAllModule = createAsyncThunk('moduleSlice/getAllModule', async () => {
    try {
        let response = await axios.get('/module', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// ** Create Module
export const createModule = createAsyncThunk('moduleSlice/createModule', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/module', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Module added successfully.');
        await dispatch(getAllModule());
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// ** Update Module
export const updateModule = createAsyncThunk('moduleSlice/updateModule', async ({ id, data }, { dispatch }) => {
    try {
        let response = await axios.put('/module/' + id, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Module updated successfully.');
        await dispatch(getAllModule());
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// ** Delete Module
export const deleteModule = createAsyncThunk('moduleSlice/deleteModule', async (id, { dispatch }) => {
    try {
        let response = await axios.delete('/module/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Module deleted successfully.');
        await dispatch(getAllModule());
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// ** Update Module Status
export const updateModuleStatus = createAsyncThunk('moduleSlice/updateModuleStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/module/status/' + id, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        await dispatch(getAllModule());
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const initialModulePageActiveTab = () => {
    const item = window.localStorage.getItem('modulePageActiveTab');
    return item ? JSON.parse(item) : themeConfig.layout.modulePageActiveTab;
};

export const moduleSlice = createSlice({
    name: 'moduleSlice',
    initialState: {
        options: [],
        selectedRole: {},
        module: [],
        modulePageActiveTab: initialModulePageActiveTab()
    },
    reducers: {
        handleModuleTab: (state, action) => {
            state.modulePageActiveTab = action.payload;
            localStorage.setItem('modulePageActiveTab', JSON.stringify(action.payload));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllModule.fulfilled, (state, action) => {
            state.module = action?.payload;
        });
    }
});

export const { handleModuleTab } = moduleSlice.actions;

export default moduleSlice.reducer;